import * as React from "react";
import Checkbox from "@mui/material/Checkbox";
import ListItemText from "@mui/material/ListItemText";
import CustomMenuItem from "./Menu/CustomMenuItem";
import CustomMenu from "./Menu";
import { useCallback } from "react";

const MultiSelctCheckboxDropdown = ({
  items,
  selectedItems,
  onSelectionChange,
  anchorEl,
  handleClose,
  valueKey,
  displayKey,
  handleClearFilter,
  renderDisplay,
  menuProps,
  isShowUnassigned = false,
  searchAssignee = true
}) => {

  const handleSelect = useCallback((item) => {
    let itemValue;
    if (item === 'unassigned') {
      itemValue = 'unassigned'
    } else {
      itemValue = item[valueKey];
    }
    const updatedSelection = selectedItems?.includes(itemValue)
      ? selectedItems?.filter((selected) => selected !== itemValue)
      : [...selectedItems, itemValue];

    onSelectionChange(updatedSelection);
  }, [selectedItems, onSelectionChange]);
  
  return (
    <>
      <CustomMenu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        {...menuProps} // Allow additional menu props to be passed
      >
        <CustomMenuItem
          className="d-flex justify-content-center clear-filter-color"
          onClick={handleClearFilter}
        >
          Clear Filters
        </CustomMenuItem>
        {
          (isShowUnassigned && searchAssignee) && <CustomMenuItem onClick={() => handleSelect('unassigned')}>
            <Checkbox
              className="checkbox"
              checked={selectedItems?.includes('unassigned')}
            />
            <ListItemText
              className="ml-3"
              primary={'unassigned'}
            />
          </CustomMenuItem>
        }

        {items?.map((item, index) => (
          <CustomMenuItem key={`userAssigneeList-${index}`} onClick={() => handleSelect(item)}>
            <Checkbox
              className="checkbox"
              checked={selectedItems?.includes(item?.[valueKey])}
            />
            <ListItemText
              className="ml-3"
              primary={renderDisplay ? renderDisplay(item) : item[displayKey]}
            />
          </CustomMenuItem>
        )
        )}
      </CustomMenu>
    </>
  );
};

export default React.memo(MultiSelctCheckboxDropdown);
